<template>
  <IAMEntityMutationModal
    :loading="loading"
    :entity="tenant"
    :show-name="true"
    :create-title-key="'iam.tenants.header.create_tenant'"
    :update-title-key="'iam.tenants.header.update_tenant'"
    :name-placeholder-key="'iam.tenants.name_placeholder'"
    :description-placeholder-key="'iam.tenants.description_placeholder'"
    :address-placeholder-key="'iam.tenants.address_placeholder'"
    :postal-code-placeholder-key="'iam.tenants.postalCode_placeholder'"
    :city-placeholder-key="'iam.tenants.city_placeholder'"
    :region-placeholder-key="'iam.tenants.region_placeholder'"
    :website-placeholder-key="'iam.tenants.website_placeholder'"
    :email-placeholder-key="'iam.tenants.email_placeholder'"
    :external-id-placeholder-key="'iam.tenants.externalId_placeholder'"
    @close="emit('close')"
    @mutate="handleMutate"
  />
</template>

<script setup lang="ts">
import { CreateTenant, Tenant, UpdateTenant } from '@infuse/api/iam/tenant';
import { IAMEntityMutationModal } from '@infuse/iam/components';

const props = withDefaults(
  defineProps<{
    loading?: boolean;
    tenant?: Tenant;
  }>(),
  {
    loading: false
  }
);

interface Emits {
  (event: 'close'): void;
  (event: 'mutate', vars: { id: string | undefined; tenant: CreateTenant | UpdateTenant }): void;
}

const emit = defineEmits<Emits>();

const handleMutate = ({ id, entity }: { id: string | undefined; entity: any }) => {
  emit('mutate', {
    id,
    tenant: {
      name: entity.name,
      description: entity.description,
      externalId: entity.externalId,
      address: entity.address,
      postalCode: entity.postalCode,
      city: entity.city,
      country: entity.country,
      region: entity.region,
      website: entity.website,
      email: entity.email,
      type: entity.type
    }
  });
};
</script>
